import React, { useRef, forwardRef, useImperativeHandle } from 'react';

import { IAdvBoxAttributes } from '../../../typings/adv';
import GalleryTabsWrapper from '../../organisms/gallery-tabs-wrapper/gallery-tabs-wrapper';
import { sportsDetailCardtypes } from '../../../typings/sports-detail';
import t from '../../../labels/labelling-utils';

export enum observedTypes {
  PLAYER_FULL = 'player-full',
  ADV = 'adv',
}
export interface IDriver {
  teamId?: string;
  driverId?: string;
  firstName?: string | null;
  lastName?: string | null;
  teamName?: string | null;
  teamUrl: string;
  logoUrl: string;
  position: string;
  points: string;
  url?: string;
  imageUrl?: string;
  seoTeamName: string;
}

export interface ITeam {
  teamId?: string;
  teamName?: string | null;
  url: string;
  logoUrl: string;
  position: string;
  points: string;
  imageUrl?: string;
  seoTeamName: string;
}

export interface ISeasonRankingPageProps {
  drivers: IDriver[];
  teams: ITeam[];
  competitionSlugName: string;
  advsByHeadshots?: number;
  competitionName: string;
  advBoxAttributes?: IAdvBoxAttributes;
  trackingData?: any;
  analyticsElement?: string;
  fakeAdvs?: boolean;
}

const cardsColor = '#f6f6f6';

const SeasonRankingPage = forwardRef<unknown, ISeasonRankingPageProps>((props: ISeasonRankingPageProps, ref) => {
  const { drivers, teams, fakeAdvs = false, advBoxAttributes, trackingData } = props;

  const tabsWrapper = useRef<HTMLDivElement[]>(null);

  useImperativeHandle(ref, () => {
    return {
      tabsRef: tabsWrapper.current,
    };
  });

  const tabs = [
    {
      tabName: t('motorsports.team.drivers'),
      cards: drivers,
      tabItemColor: cardsColor,
      type: sportsDetailCardtypes.DRIVERS,
      tabsIntcmp: trackingData?.intCmpTabDrivers,
      dataElement: t('motorsports.drivers.slug'),
      cardsIntcmp: {
        playerCard: trackingData?.intCmpCardFull,
        playerTeam: trackingData?.intCmpCardLogo,
      },
    },
    {
      tabName: t('motorsports.teams'),
      cards: teams,
      tabItemColor: cardsColor,
      type: sportsDetailCardtypes.TEAMS,
      tabsIntcmp: trackingData?.intCmpTabTeams,
      dataElement: t('motorsports.teams.slug'),
      cardsIntcmp: {
        playerCard: trackingData?.intCmpCardFull,
        playerTeam: trackingData?.intCmpCardLogo,
      },
    },
  ];

  return (
    <GalleryTabsWrapper
      ref={tabsWrapper}
      tabs={tabs}
      title={t('season.ranking.page.title')}
      footerButtonLabel={t('season.ranking.page.label')}
      fakeAdvs={fakeAdvs}
      advBoxAttributes={advBoxAttributes}
    />
  );
});

SeasonRankingPage.displayName = 'SeasonRankingPage';

export default SeasonRankingPage;
